/**
 * @description: 项目入口文件
 * @author: nowThen
 */

import 'regenerator-runtime/runtime';
import Vue from 'vue';
import App from './App.vue';
import router from './routers/';
import './routers/intercept';
import store from './stores';
import * as filters from './filters/';
import VueI18n from 'vue-i18n';
import './services';
import 'lib-flexible';
import VueLazyload from 'vue-lazyload';

import './styles/main.less';

import FastClick from 'fastclick';

FastClick.attach(document.body);
Vue.use(VueLazyload)

Vue.use(VueI18n)

const messages = {
  cn: {
    home: '首页',
    women: '女士灵感',
    spring22: '2022春',
    campaignSpring22: '2022春季广告大片',
    lookbookSpring22: '2022春季产品<span class="mecity">LOOKBOOK</span>',
    autumn21: '2021秋',
    campaignAutumn21: '2021秋季广告大片',
    lookbookAutumn21: '2021秋季产品<span class="mecity">LOOKBOOK</span>',
    winter21: '2021冬',
    campaignWinter21: '2021冬季广告大片',
    lookbookWinter21: '2021冬季产品<span class="mecity">LOOKBOOK</span>',
    men: '男士灵感',
    about: '关于',
    article: '品牌故事',
    news: '品牌动向',
    stores: '线下商店',
    // conceptStores: '概念店',
    otherStores: '门店信息',
    followUs: '关注我们'
  },
  us: {
    home: 'HOME',
    women: 'WOMEN',
    spring22: 'SPRING 2022',
    autumn21: 'AUTUMN 2021',
    winter21: 'WINTER 2021',
    campaignSpring22: 'CAMPAIGN',
    lookbookSpring22: 'LOOKBOOK',
    campaignAutumn21: 'CAMPAIGN',
    lookbookAutumn21: 'LOOKBOOK',
    campaignWinter21: 'CAMPAIGN',
    lookbookWinter21: 'LOOKBOOK',
    men: 'MEN',
    about: 'ABOUT',
    article: 'MECITY SINCE 2008',
    news: 'NEWS',
    stores: 'STORES',
    // conceptStores: 'CONCEPT STORE',
    otherStores: 'OTHER STORES',
    followUs: 'FOLLOW US'
  }
}
const i18n = new VueI18n({
  locale: 'cn',
  messages,
  fallbackLocale: 'us'
})
Vue.config.errorHandler = (err, vm, info) => {
  console.error(err);
};
Vue.config.devtools = process.env.NODE_ENV === 'development';
Vue.config.productionTip = process.env.NODE_ENV === 'production';

window.EventBus = new Vue();

// 注册过滤器
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});
window.myVue = new Vue({
  router,
  store,
  render: h => h(App),
  i18n
}).$mount('#app')
